import pathOr from 'ramda/es/pathOr';
import {API} from '../constants';

export default pathOr('TmtHakuWidgets', [API, '_config', 'widgetId']);
